module.exports = __webpack_public_path__ + "static/media/death.1cb20fbc.PNG";